<script lang="ts">
    import { openModal } from 'svelte-modals';
    import { _ } from 'svelte-i18n';

    import ModalZoneFromCoordsParams from './ModalZoneFromCoordsParams.svelte';
    import type { ZoneFromCoordsParams } from './ModalZoneFromCoordsParams.svelte';
    import SelectVehicle from "../Vehicles/SelectVehicle.svelte";
    import deliveryIconSrc from '../../shared/Icons/svg/door-open.svg';
    import distanceIconSrc from '../../shared/Icons/svg/arrow_range_24dp_1F1F1F_FILL0_wght400_GRAD0_opsz24.svg';
    import ButtonSmallBlack from '../../shared/ButtonSmallBlack.svelte';
    import StyleLikeFilterItem from '../../shared/StyleLikeFilterItem.svelte';
    import IconStylusAsButton from '../../shared/Icons/IconStylusAsButton.svelte';
    import IconCalendar from '../../shared/Icons/IconCalendar.svelte';
    import { FriendlyDateGenerator } from '../../utilities/FriendlyDateGenerator';

    export let params: ZoneFromCoordsParams;
    export let alreadyUsedVehicles: number[];
    export let onParamsChange: (params: ZoneFromCoordsParams) => void = (params) => {};
    export let onClose: () => void = () => {};

    let selectedVehicle: number;
    let friendlyDate: FriendlyDateGenerator = new FriendlyDateGenerator(params.day, true);
    let date: string;

    function editParams() {
        let props: any = Object.assign(params || {}, {
            paramsOnly: true,
            alreadyUsedVehicles,
            allowUseAlreadyUsedVehicle: false,
            allowToRemoveAssignment: false,
            onProceed: async (newparams: ZoneFromCoordsParams) => {
                params = Object.assign(params, newparams, {vehicleIds: params.vehicleIds});
                onParamsChange(params);
                return true;
            }
        });
        props.limit = props.limit.toString();
        props.radius = props.radius.toString();
        openModal(ModalZoneFromCoordsParams, props);
    }

    $: {
        if (params?.vehicleIds?.length && !alreadyUsedVehicles.includes(params.vehicleIds[0])) {
            selectedVehicle = params.vehicleIds[0];
        } else {
            selectedVehicle = 0;
        }
        friendlyDate.set(params.day);
        if (friendlyDate.getRelativeTodayText()) {
            date = $_(friendlyDate.getRelativeTodayText());
        } else {
            date = friendlyDate.getDayAndMonthNumeric();
        }
    }
</script>

<div class="container">
    <div>
        {$_('zone-from-coords-ctrl-click-to-create')}
    </div>
    <div class="vehicle-selector">
        <StyleLikeFilterItem mode="vehicle">
            <SelectVehicle selected={selectedVehicle} {alreadyUsedVehicles} prompt="bez pojazdu" onChange={(selected) => {
                params.vehicleIds = [selected || 0];
                return true;
            }}/>
        </StyleLikeFilterItem>
    </div>
    <div class="zone-params">
        <div class="zone-param">
            <img src="{deliveryIconSrc}" alt="{$_('zone-from-coords-jobs-limit')}"/>
            {params.limit}
        </div>
        <div class="zone-param">
            <img src="{distanceIconSrc}" alt="{$_('zone-from-coords-radius')}"/>
            {params.radius}  <span>km</span>
        </div>
        <div class="zone-param">
            <IconCalendar scale={0.6}/>
            {date}
        </div>
        <IconStylusAsButton scale={0.55} backgroundColor="#000000" title="{$_('zone-from-coords-edit-params')}" on:click={editParams}/>
    </div>
    <div class="buttons">
        <ButtonSmallBlack text="{$_('finish')}" showIcon={false} on:click={onClose}/>
    </div>
</div>

<style>
    .container {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        height: 100%;
    }
    .zone-params {
        display: flex;
        align-items: center;
        background-color: #e5e3e3;
        padding: 0 4px 0 10px;
        border-radius: 14px;
        min-height: 26px;
        font-size: 14px;
        line-height: 14px;
    }
    .zone-param {
        display: flex;
        align-items: center;
        margin-right: 15px;
    }
    .zone-param img {
        height: 16px;
        margin-right: 3px;
    }
    .zone-param span {
        display: inline-block;
        margin-left: 2px;
        opacity: 0.7;
    }
</style>